import {Component, Inject} from '@angular/core';
import {Router} from '@angular/router';
import {PlanningMachineCarpetRun} from '@domain/planning/carpet/planning-machine-carpet-run';
import {PlanningItemType} from '@domain/planning/planning-item-type.enum';
import {PlanningMachineRun} from '@domain/planning/planning-machine-run';
import {PlanningOrder} from '@domain/planning/planning-order';
import {PlanningMachineWeavingRun} from '@domain/planning/weaving/planning-machine-weaving-run';
import {AUTHENTICATION, Authentication} from '@infrastructure/http/authentication/authentication';
import {TranslateService} from '@vdw/angular-component-library';
import {get} from 'lodash-es';
import {BasePlanningItemComponent} from '../base-planning-item.component';

@Component({
  selector: 'app-planning-item-details',
  templateUrl: './planning-item-details.component.html',
  styleUrls: ['./planning-item-details.component.scss']
})
export class PlanningItemDetailsComponent extends BasePlanningItemComponent {
  private static readonly unknownPlanningItemTranslationKey = 'PLANNING.UNKNOWN';
  private readonly translate: TranslateService;

  public constructor(
    @Inject(AUTHENTICATION) protected readonly authentication: Authentication,
    translate: TranslateService,
    router: Router
  ) {
    super(authentication, router);

    this.translate = translate;
  }

  public getMachineQualityLabel(): string {
    return get((this.planningItem as PlanningMachineCarpetRun).machineQuality, 'technicalName', this.translate.instant(PlanningItemDetailsComponent.unknownPlanningItemTranslationKey));
  }

  public getCreelLabel(): string {
    return get((this.planningItem as PlanningMachineCarpetRun).creel, 'name', this.translate.instant(PlanningItemDetailsComponent.unknownPlanningItemTranslationKey));
  }

  public getWeavePatternLabel(): string {
    return get((this.planningItem as PlanningMachineWeavingRun).weaveProduct, 'name', this.translate.instant(PlanningItemDetailsComponent.unknownPlanningItemTranslationKey));
  }

  public getPlanningItemTypeLabel(): string {
    return `PLANNING.ADD_ITEM.TYPES.${PlanningItemType[this.planningItem.type]}`;
  }

  public canShowActions(): boolean {
    return this.isPlanningItemOfTypeRun() && !(this.planningItem as PlanningMachineCarpetRun).completed;
  }

  public canDeletePlanningItem(): boolean {
    return !(this.planningItem as PlanningMachineRun).executing;
  }

  public getPlanningOrders(): PlanningOrder[] {
    return (this.planningItem as PlanningMachineRun).planningOrders;
  }
}
